import { useEffect } from 'react';

export const useMikMakTag = (appId = '677eb3b8ac006a063295e1a4', dnt = false) => {
  useEffect(() => {
    try {
      //console.log("loading MikMak script:");
      const a = window.swnDataLayer = window.swnDataLayer || {};
      a.appId = appId || a.appId;
      a.eventBuffer = a.eventBuffer || [];
      a.loadBuffer = a.loadBuffer || [];
      a.push = a.push || function(e) { a.eventBuffer.push(e); };
      a.load = a.load || function(e) { a.loadBuffer.push(e); };
      a.dnt = a.dnt != null ? a.dnt : dnt;

      // Load MikMak tag script
      const existingScript = document.querySelector(`script[src*="${appId}/tag.min.js"]`);
      if (!existingScript) {
        const t = document.getElementsByTagName('script')[0];
        const n = document.createElement('script');
        n.async = true;
        n.src = `//wtb-tag.mikmak.ai/scripts/${appId}/tag.min.js`;
        t.parentNode.insertBefore(n, t);
      }
    } catch (e) {
      console.log("Error loading MikMak script:", e);
    }
  }, [appId, dnt]);
};
